import classNames from "classnames";
import { Avatar } from "components/DesignSystem/AvatarGroup/Avatar";
import { AvatarGroup } from "components/DesignSystem/AvatarGroup/AvatarGroup";
import { Button } from "components/DesignSystem/Button/Button";

export type ThreadParticipant = {
  name: string;
  profile_url: string;
  image: string;
  id: string;
};

export const MessageThreadReplyCount = ({
  threadParticipants = [],
  replyCount,
  openThreadSlider,
  sentByTheUser,
}: {
  threadParticipants?: ThreadParticipant[];
  replyCount: number;
  openThreadSlider: () => void;
  sentByTheUser: boolean;
}) => {
  return (
    <div
      className={classNames("t-mt-1 t-flex t-gap-2 t-items-center", {
        "t-ml-10": !sentByTheUser,
      })}
    >
      <AvatarGroup max={4} variant="no-fill">
        {threadParticipants?.map(({ profile_url, name, image, id }) => (
          <Avatar
            className="t-ring-white t-ring-2 t-box-border"
            key={id}
            alt={name}
            src={image || profile_url || name}
            size="extra-small"
          />
        ))}
      </AvatarGroup>
      <Button customType="link" size="small" onClick={openThreadSlider}>
        {replyCount} Replies
      </Button>
    </div>
  );
};
